import { AppShell } from "./app/AppShell";
import { useRoute } from "./lib/route";
import { PatternsPage } from "./pages/PatternsPage";
import { BoardPage } from "./pages/BoardPage";
import { IssuePage } from "./pages/IssuePage";
import { DashboardPage } from "./pages/DashboardPage";
import { MilestonesPage } from "./pages/MilestonesPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { ConnPage } from "./pages/ConnPage";
import { GitPage } from "./pages/GitPage";
import { CodePage } from "./pages/CodePage";
import { LogsPage } from "./pages/LogsPage";
import { SessionPage } from "./pages/SessionPage";
import { QueuePage } from "./pages/QueuePage";
import { GraphPage } from "./pages/GraphPage";
import { HelpPage } from "./pages/HelpPage";
import { HistoryPage } from "./pages/HistoryPage";
import { SettingsPage } from "./pages/SettingsPage";
import { OAuthApprovePage } from "./pages/OAuthApprovePage";
import { ServersPage } from "./pages/ServersPage";
import { AlarmsPage } from "./pages/AlarmsPage";
import { TidyPage } from "./pages/TidyPage";
import { AccountPage } from "./pages/AccountPage";
import { ChoresPage } from "./pages/ChoresPage";
import { OrgsPage } from "./pages/OrgsPage";
import { AuthGate } from "./app/AuthGate";
import { EmptyState } from "./components/Card";
import { PageHead } from "./components/Page";
import { AppPwaNotice } from "./components/Pwa";
import { ChatDockProvider } from "./chat/dock";
import { ChatDrawer } from "./chat/ChatDrawer";
import { tx } from "./i18n";



/** 아직 안 세운 화면. **빈 화면을 그냥 두지 않는다** — 고장인지 아직 없는 것인지
 *  구분이 안 되면 사람은 새로고침부터 한다. */
function NotYet({ route, title }: { route: string; title: string }) {
  return (
    <AppShell route={route}>
      <PageHead title={title} />
      <EmptyState title={tx("notYet.empty")} desc={tx("notYet.desc")} />
    </AppShell>
  );
}

function Screen({ route }: { route: string }) {
  if (route === "/patterns") return <PatternsPage />;
  if (route === "/board") return <BoardPage />;
  if (route === "/issue") return <IssuePage />;
  if (route === "/milestones") return <MilestonesPage />;
  if (route === "/projects") return <ProjectsPage />;
  if (route === "/tidy") return <TidyPage />;
  if (route === "/alarms") return <AlarmsPage />;
  if (route === "/conn") return <ConnPage />;
  if (route === "/git") return <GitPage />;
  if (route === "/code") return <CodePage />;
  if (route === "/logs") return <LogsPage />;
  if (route === "/session") return <SessionPage />;
  if (route === "/history") return <HistoryPage />;
  if (route === "/queue") return <QueuePage />;
  if (route === "/graph") return <GraphPage />;
  if (route === "/help") return <HelpPage />;
  if (route === "/servers") return <ServersPage />;
  if (route === "/chores") return <ChoresPage />;
  if (route === "/orgs") return <OrgsPage />;
  if (route === "/settings") return <SettingsPage />;
  if (route === "/oauth/approve") return <OAuthApprovePage />;
  if (route === "/account") return <AccountPage />;
  if (route === "/") return <DashboardPage />;
  return <NotYet route={route} title={tx("notYet.title")} />;
}

/** 채팅 겉창은 **화면 밖**에 한 번 선다 — 화면마다 셸을 감싸므로 셸 안에 두면 화면을 옮길 때
 *  겉창이 닫히고 쓰던 말이 날아간다. 상태(열림·무엇을 보나)도 같은 이유로 여기 문맥에 산다. */
export function App() {
  const route = useRoute();
  // 문지기가 **맨 밖**이다 — 겉창 · 알람도 로그인 뒤의 API 를 부르므로 그 안에 둔다.
  // PWA 안내만은 밖에 둔다: 로그인 화면에서도 「새 버전」·「서버 연결 안 됨」은 말해야 한다.
  return (
    <>
      <AuthGate>
        <ChatDockProvider>
          <Screen route={route} />
          <ChatDrawer />
        </ChatDockProvider>
      </AuthGate>
      <AppPwaNotice />
    </>
  );
}
